<template>
    <el-dialog
        class="withdrawal"
        :visible.sync="withdrawalVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Withdrawal"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="withdrawalForm"
                :rules="rules" 
                :model="withdrawalForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Current Balance"
                            size="small"
                        >
                            <span class="withdrawal-num"
                                >$ {{ currentBalance }}</span
                            >
                            <span class="withdrawal-all" @click="fill()">Withdrawal all</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item
                            label="Amount"
                            size="small"
                            prop="num"
                        >
                            <el-input
                                clearable
                                placeholder=""
                                maxlength="200"
                                size="small"
                                v-model="withdrawalForm.num"
                            >
                                <i slot="prefix">$</i>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item
                            label="Remark"
                            size="small"
                        >
                            <el-input
                                clearable
                                placeholder=""
                                maxlength="200"
                                size="small"
                                v-model="withdrawalForm.remark"
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 6 }"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >withdrawal</el-button
            >
            <el-button size="small" @click="withdrawalVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        let checkAmount = (rule, value, callback) => {
            if (value == '' || parseFloat(this.currentBalance) < parseFloat(value)) {
                return callback(new Error("Cash withdrawal amount  must be>0 and ≤ balance"));
            } else {
                callback();
            }
        };
        return {
            currentBalance: "0.00",
            withdrawalForm: {
                num: "",
                remark: "",
                amount: "",
            },
            checked: false,
            rules: {
                num: [
                    {
                        required: false,
                        trigger: "blur",
                        validator: checkAmount,
                    },
                ],
            },
        };
    },
    methods: {
        amountChange(val) {
            this.withdrawalForm.num = val;
        },
        fill(){
            this.$refs["withdrawalForm"].clearValidate();
            this.withdrawalForm.num = this.currentBalance;
        },
        save() {
            this.$refs["withdrawalForm"].validate((valid) => {
                if (valid) {
                    this.$confirm("Confirm to withdrawal?", "withdrawal", {
                        type: "warning",
                    }).then(() => {
                        this.loading = true;
                        cmofferApi.withdrawal(
                            {
                                amount: this.withdrawalForm.num,
                                admin_pay: this.tableItem.id,
                                remark: this.withdrawalForm.remark,
                                pay_method: 'balance'
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            this.closeDialog();
                            this.$parent[this.funcName]();
                            this.$message.success(
                                this.$i18n.locale == "zh" ? "成功" : "Success"
                            );
                        });
                    }).catch(() => {
                        this.$message.info("withdrawal failed!");          
                    });
                }
            });  
        },
        getEntityInfo() {
            cmofferApi.entityInfo({}, "get").then((res) => {
                if (res) {
                    this.currentBalance = res.data.balance;
                }
            });
        },
        closeDialog() {
            this.withdrawalForm = {
                num: "",
                remark: "",
                amount: "",
            };
            this.$refs["withdrawalForm"].clearValidate();
            this.$refs["withdrawalForm"].resetFields();
            this.$emit("update:withdrawalVisible", false);
        },
        async initialize() {
            // this.getEntityInfo();
        },
    },
    props: {
        withdrawalVisible: Boolean,
        tableItem: Object,
        funcName: String
    },
    watch: {
        withdrawalVisible() {
            if (this.withdrawalVisible) {
                this.currentBalance = this.tableItem.balance;
                this.initialize();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.withdrawal {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }

        .el-select {
            width: 100%;
        }

        .el-form-item--small {
            margin-bottom: 20px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
    .withdrawal-num {
        font-size: 18px;
        font-weight: 600;
    }
    .withdrawal-all{
        margin-left:30px;
        color:blue;
        font-size: 12px;
    }
    .rm-method {
        margin-top: 20px;
        ::v-deep .el-radio-group {
            width: 100%;
            .el-radio {
                display: flex;
                align-items: center;
                padding: 4px 10px;
                box-sizing: border-box;
                border: 1px solid #e1e2e3;
                font-size: 16px;
                min-height: 40px;
                background-color: #ffffff;
                margin-right: 0;
                .el-radio__label {
                    span {
                        margin-left: 5px;
                    }
                }
                & + .el-radio {
                    margin-top: 10px;
                }
                &.is-checked {
                    border-color: $color-primary-blue;
                }
            }
        }
    }
}
</style>
